module.exports = __webpack_public_path__ + "img/video.9b534ce9.svg";